import { render, staticRenderFns } from "./ContainerChoice.vue?vue&type=template&id=b2fd7d82&"
import script from "./ContainerChoice.vue?vue&type=script&lang=js&"
export * from "./ContainerChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports